import React, { Component } from 'react'

import DisbursementRequestList from "components/DisbursementRequestList/DisbursementRequestList";

export default class DisbursementRequestListView extends Component {
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="header">Solicitudes de desembolso</h1>
                    </div>
                </div>

                <DisbursementRequestList />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/DisbursementRequestListView/DisbursementRequestListView.jsx